module.exports = __webpack_public_path__ + "static/img/arrow-right.2509423e.svg";